import { useEffect, useState } from "react";
import GoogleStore from "../../assets/GoogleStore.svg";
import AppleStore from "../../assets/AppleStore.svg";
import iphone_13_pro_4x from "../../assets/iphone_13_pro_4x.webp";
import HeroImage from "../../assets/HeroImage.webp";
import Button from "../button/Button";
import LazyLoad from "react-lazyload";
import "./hero.css";

const HeroSection = () => {
  const [showFirst, setShowFirst] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowFirst((prev) => !prev);
    }, 4000); // Change visibility every 2 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);
  return (
    <div
      className="container pt-lg-0 HomeSection"
      style={{ marginTop: "120px", width: "87%" }}
    >
      <div className="row d-flex">
        {/* Left Section */}
        <div className="heroContent col-lg-6 col-12 d-flex flex-column justify-content-center  mb-5 text-center text-lg-start">
          <h1
            className="mb-4 fw-bold text-lg-start"
            style={{ fontSize: "clamp(38px, 5vw, 64px)" }}
          >
            Maximize Your Gift Card's Worth! 🚀
          </h1>
          <p className="text-lg-start">
            Sell your gift cards for the highest price.
            <br />
            Quick payout guaranteed
          </p>
          <div className="d-flex justify-content-start align-items-center heroBtn">
            <Button className="consistent-width my-3" actionType="redirect" redirectUrl="https://dashboard.giftcard8.com/account" id="sellNowBtn">Sell Now</Button>
          </div>
          <div className="my-4 d-flex gap-3">
            <a
              href="https://play.google.com/store/apps/details?id=com.yihua.giftcard"
              target="_blank"
              rel="noopener noreferrer"
              alt="Google Store"
            >
              <LazyLoad>
                <img
                  src={GoogleStore}
                  alt="Google Store"
                  className="store-img"
                />
              </LazyLoad>
            </a>
            <a
              href="https://apps.apple.com/ng/app/giftcard8-redeem-gift-cards/id6746798308"
              target="_blank"
              rel="noopener noreferrer"
              alt="Apple Store"
            >
              <LazyLoad>
                <img
                  src={AppleStore}
                  alt="Apple Store"
                  className="store-img img-fluid"
                />
              </LazyLoad>
            </a>
          </div>
        </div>

        {/* Right Section */}
        {/* Right Section */}
        <div className="col-lg-6 col-12 d-flex justify-content-center align-items-center mb-5 d-none d-lg-flex">
          <div
            className="iphone-img-container position-relative"
            style={{ width: "100%", height: "650px", overflow: "hidden" }}
          >
            <LazyLoad>
              <img
                src={iphone_13_pro_4x}
                className={`iphone-img img1 hover-effect ${
                  showFirst ? "fade-in" : "fade-out"
                }`}
                alt="iPhone 13 Pro"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "65%",
                  transform: "translate(-50%, -50%)",
                  width: "auto",
                  height: "100%",
                  objectFit: "contain",
                  zIndex: showFirst ? 2 : 1,
                }}
              />
            </LazyLoad>
            <LazyLoad>
              <img
                src={HeroImage}
                className={`iphone-img img2 hover-effect ${
                  !showFirst ? "fade-in" : "fade-out"
                }`}
                alt="GiftCard8 app screenshot"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "75%",
                  transform: "translate(-50%, -50%)",
                  width: "auto",
                  height: "80%",
                  objectFit: "contain",
                  zIndex: !showFirst ? 2 : 1,
                }}
              />
            </LazyLoad>
            <style>
              {`
        .fade-in {
          opacity: 1;
          transition: opacity 1s ease-in-out;
        }
        .fade-out {
          opacity: 0;
          transition: opacity 1s ease-in-out;
        }
      `}
            </style>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
